import { WALLET } from '../../brands/default/constants';
import { URLWALLET } from '../../brands/default/services';
import axios from '../../components/_generic/axiosSplunk/axiosSplunk';
import httpCommonHeaders from '../../helpers/httpCommonHeaders';

export const getWallet = () => async (dispatch) => {
  dispatch(resetWallet());
  try {
    const response = await axios({
      cache: false,
      headers: httpCommonHeaders(),
      method: 'GET',
      url: URLWALLET,
      validateStatus: (status) => {
        return status < 500;
      },
      withCredentials: true,
    });

    if (response.status !== (200 || 202)) {
      dispatch(errorWallet());
    } else {
      dispatch(setWallet(response.data));
    }
  } catch {
    dispatch(errorWallet());
  }
};

export const setWallet = (userWallet) => (dispatch) => {
  return dispatch({ type: WALLET.SET_WALLET, userWallet });
};

export const errorWallet = () => (dispatch) => {
  return dispatch({ type: WALLET.ERROR_WALLET });
};

export const resetWallet = () => (dispatch) => {
  return dispatch({ type: WALLET.RESET_WALLET });
};
